import { ModuleNav, COMPONENT_NAME } from './module-nav';

/**
 * jQuery Component Wrapper for Module Nav
 * @param {object} [settings] incoming Settings
 * @returns {jQuery[]} elements to be acted on
 */
$.fn.modulenav = function (settings) {
  return this.each(function () {
    let instance = $.data(this, COMPONENT_NAME);
    if (!instance) {
      const existingSettings = $(this).data('modulenav-settings');
      const mergedSettings = existingSettings ? { ...existingSettings, ...settings } : settings;
      instance = $.data(this, COMPONENT_NAME, new ModuleNav(this, mergedSettings));
      $(this).data('modulenav-settings', instance.settings);
    } else {
      instance.updated(settings);
    }
  });
};
